import React from 'react';
import PropTypes from 'prop-types';
import styles from './MessageSentContent.module.scss';
import {OutlineMessageIcon} from "presentation/common/components/style-guide/icons";

const DefaultMessageTemplate = (props) => {
  return <span className="flex flex-col">
    <span>Le hemos enviado a {props.targetTpl} el enlace seguro para efectuar el pago.</span>
    <span className={styles.warning}>Si el correo no está en su bandeja de entrada verifique la carpeta SPAM.</span>
  </span>
}

export const MessageSentContent = (props) => {
  const {
    target,
    targetTpl = (<a href={`mailto:${target}`} className="font-bold">{target}</a>),
    messageTpl = (<DefaultMessageTemplate targetTpl={targetTpl}/>),
    message,
    title,
  } = props;

  return (
    <div className={styles.container}>
      <div className="text-center"><OutlineMessageIcon /></div>
      <h3 className="modal-title text-center pt-1 pb-3">{title}</h3>
      <p className="text-center pb-3">{message ? message : messageTpl}</p>
    </div>
  );
};

MessageSentContent.propTypes = {
  message: PropTypes.string,
  target: PropTypes.string,
  targetTpl: PropTypes.node,
  MessageTpl: PropTypes.node,
  title: PropTypes.string,
};

MessageSentContent.defaultProps = {
  target: 'antonio@gmail.com',
  title: '¡Revise su correo electrónico!',
};

export default React.memo(MessageSentContent);
